<template>
  <div
    class="loader-screen"
    :class="{
      /* 'loader-screen--dark': theme === 'dark', */
      'loader-screen--light': true
    }"
  >
    <div
      class="loader-screen__logo-container"
      @click="onLogoClick"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 296.12 227.33" v-bind:class="'logo--dark'" :class="{
          animate: loading,
        }" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><linearGradient id="b" x1="65.48" y1="113.67" x2="214.03" y2="113.67" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#e6e7e8"/><stop offset="1" stop-color="#323233"/></linearGradient><linearGradient class="dark-pulse-2-target" id="d" x1="155.04" y1="112.13" x2="296.12" y2="112.13" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#c5c7c8"/><stop offset="1" stop-color="#323233"/></linearGradient><clipPath id="a"><path d="M65.48 34.37s2.37 1.37 6.53 3.38q-3.18-1.7-6.53-3.38M216.13 0H215C180.35 82.94 96.08 49.43 72 37.75c146.51 78.52 14.84 189.58 14.84 189.58C216.83 127.14 217 17.69 216.13 0z"/></clipPath><clipPath id="c"><path class="cls-1" d="M296.12 191.82s-2.14-1.45-5.93-3.64q2.88 1.81 5.93 3.64m-144.86 24.61c38-79.11 116.74-41.05 138.93-28.25C156.93 103.93 289 7.83 289 7.83c-141.65 93.81-137.74 208.6-137.74 208.6z"/></clipPath></defs><g data-name="Layer 2"><g data-name="Layer 1"><g class="dark-pulse-target" clip-path="url(#a)"><path fill="url(#b)" d="M65.48 0h153.04v227.33H65.48z"/></g><g clip-path="url(#c)"><path fill="url(#d)" d="M147.35 7.83h148.77v208.59H147.35z"/></g><path d="M57.64 108.29a12.93 12.93 0 014.82.86 11.25 11.25 0 013.69 2.37 10.41 10.41 0 012.34 3.48 11.19 11.19 0 01.81 4.27 12 12 0 01-1.48 6.08 9.33 9.33 0 01-4.82 3.92v.11a6.67 6.67 0 012.68 1.37 7.31 7.31 0 011.73 2.17 10.27 10.27 0 011 2.76 26.09 26.09 0 01.42 3c0 .63.07 1.37.11 2.23s.1 1.73.19 2.62a17.9 17.9 0 00.45 2.54 5.8 5.8 0 00.92 2h-8.79a15.54 15.54 0 01-.89-4.52c-.11-1.75-.28-3.42-.51-5a7.91 7.91 0 00-1.89-4.55q-1.45-1.45-4.74-1.45h-8.76v15.57h-8.76v-39.83zm-3.13 18A6.63 6.63 0 0059 125c1-.89 1.51-2.34 1.51-4.35a5.28 5.28 0 00-1.51-4.24 6.68 6.68 0 00-4.52-1.31h-9.56v11.21zM100 147.82a14.63 14.63 0 01-5.7 1.18 20.41 20.41 0 01-8.23-1.59 17.67 17.67 0 01-6.17-4.38 19.44 19.44 0 01-3.85-6.56 24.1 24.1 0 01-1.34-8.12 25 25 0 011.34-8.28 19.94 19.94 0 013.85-6.67 17.61 17.61 0 016.17-4.4 20.08 20.08 0 018.23-1.62 19.5 19.5 0 015.94.92 16.8 16.8 0 015.19 2.71 14.59 14.59 0 015.66 10.43h-8.37a8.35 8.35 0 00-3-5 8.74 8.74 0 00-5.41-1.68 10.21 10.21 0 00-5 1.15 9.39 9.39 0 00-3.35 3.06 13.43 13.43 0 00-1.87 4.39 21.78 21.78 0 00-.59 5.07 20.33 20.33 0 00.59 4.89 13.15 13.15 0 001.87 4.27 9.5 9.5 0 003.35 3 10.1 10.1 0 005 1.15 8.54 8.54 0 009.48-8.59H95v-6.53h16.74v21.54h-5.58l-.9-4.52a13.17 13.17 0 01-5.26 4.18zm-70.21-39.53v7.36h-21v8.54h19.28V131H8.76v9.76h21.48v7.37H0v-39.84z" fill="#4e5053"/></g></g></svg>
    </div>
    <div
      v-if="errorShow"
      class="loader-screen__error"
    >
      <template v-if="!reloadClicked">
        <p>{{ $translate('app-loader_error_title') }}</p>
        <template v-if="errorTextArr && errorTextArr.length">
          <p
            v-for="(errorText, k) in errorTextArr"
            :key="k"
          >{{ errorText }}</p>
        </template>
      </template>
      <v-btn
        outlined
        :disabled="reloadClicked"
        @click="handleReloadClick"
        class="mt-16"
      >
        {{ $translate('app-loader_error_reload') }}
        <img
          class="ml-4"
          :class="{
            'reload-icon--rotating': reloadClicked
          }"
          src="@/assets/svg/nav-menu_refresh.svg"
        >
      </v-btn>
    </div>
    <div class="loader-screen__bottom">
      <p class="text-center small">from</p>
      <h5 class="text-center">BTS</h5>
    </div>
  </div>
</template>

<script>
import { postCustomEvent } from "@/helpers/amplitude";
import bridge from "@/helpers/bridge";
import baseApi from "@/helpers/baseApi";
import { setAuthToken } from "@/helpers/auth.js";
import * as Sentry from "@sentry/vue";
const AUTH_REQUEST_CONFIG = { 
  headers: {
    'x-bridge': bridge.detectedBridgePlatform === 'orta-bridge' 
      ? 'qollab' 
      : bridge.detectedBridgePlatform === 'aitu-bridge' 
      ? 'aitu'
      : 'not-detected'
    //aitu|qollab
  }
}
export default {
  name: 'AppLoaderScreen',
  props: ['theme'],
  data(){
    return {
      errorShow: false,
      errorCode: undefined,
      errorTextArr: [],
      phone: undefined,
      me: undefined,
      loading: true,
      reloadClicked: false,
    }
  },
  methods: {
    // TODO перелапатить процесс в одну функцию
    // async authenticate(){
    //   if (bridge.detectedBridgePlatform){

    //   } else if (process.env.NODE_ENV === "development"){
    //     try {
    //       meData = JSON.parse(process.env.VUE_APP_ME_DATA);
    //     } catch {

    //     }
    //   }
    // },
    // STEP1
    async getMe(){
      let meData;
      console.log(process.env.MODE)
      if (bridge.detectedBridgePlatform){
        meData = await bridge.getMe();
      } else if (process.env.NODE_ENV === "development"){
        try {
          meData = JSON.parse(process.env.VUE_APP_ME_DATA);
        } catch {
          throw Error(".env.development.local.example -> .env.development.local")
        }
      } else {
        throw Error(this.$translate('app-loader_error_description_no-aitu'));
      }
      this.$store.dispatch('user/setAituMeData', meData);

      return meData;
    },

    async getPhone(){
      let phoneData;
      if (bridge.detectedBridgePlatform){
        phoneData = await bridge.getPhone();
      } else if (process.env.NODE_ENV === "development"){
        try {
          phoneData = JSON.parse(process.env.VUE_APP_PHONE_DATA);
        } catch {
          throw Error(".env.development.local.example -> .env.development.local")
        }
      } else {
        throw Error(this.$translate('app-loader_error_description_no-aitu'));
      }
      this.$store.dispatch('user/setAituPhoneData', phoneData);

      return phoneData;
    },

    async authViaBridge(data){
      try {
        let res = await baseApi.put('api/user/create/', 
          data,
          AUTH_REQUEST_CONFIG,
        );
        console.log(res);
        if (res?.status === 204) {
          this.handle204(data);
        } else if (res?.data?.auth_token){
          setAuthToken(res.data.auth_token);
          this.$emit("authenticated");
        } else {
          // TODO report event via sentry
          throw Error(this.$translate('app-loader_error_description_no-put-token'));
        }
      } catch (err){
        console.log('Ree Response', err?.response);
        if (err?.response?.status === 410){
          this.handle410(data);
        } else if (err?.response?.status === 406){
          this.handle406(err, 'put');
        } else {
          this.addAuthError(err);
        }
      }
    },

    async handle204(data){
      console.log('api/user/create PUT error, trying POST')
      try {
        let res = await baseApi.post('api/user/create/', data, AUTH_REQUEST_CONFIG)
        if (res.data.auth_token){
          setAuthToken(res.data.auth_token);
          this.$emit("authenticated");
        } else {
          // TODO report event via sentry
          throw Error(this.$translate('app-loader_error_description_no-post-token'));
        }
      } catch (err) {
        if (err?.response?.status === 410){
          this.handle410(data);
        } else if (err?.response?.status === 406){
          this.handle406(err, 'post')
          this.addAuthError(err);
        } else {
          this.addAuthError(err);
        }
      }
    },

    async handle406(err, method){
      Sentry.withScope(function(scope) {
        // group errors together based on their request and response
        scope.setFingerprint(['Ошибка 406', method]);
        Sentry.captureException(err);
      });
      this.addAuthError(err);
    },

    async handle410(data){
      try {
        let res = await baseApi.post('api/user/select_auth_form/', data, AUTH_REQUEST_CONFIG);
        this.$emit('on410', res?.data?.form);
      } catch (err) {
        this.addAuthError(err);
      }
    },

    addAuthError(error){
      this.loading = false;
      this.errorShow = true;
      let errorCode = error?.response?.status;
      let finalErrorText = errorCode
        ? errorCode + ': ' + (error?.response?.data?.detail || error)
        : error?.response?.data?.detail || error;
      this.errorTextArr = [
        ...this.errorTextArr,
        finalErrorText
      ];
    },

    async handleReloadClick(){
      if (!this.reloadClicked){
        this.reloadClicked = true;
        try {
          await postCustomEvent('Перезагрузка Главной', {timeout: 1500});
        } finally {
          location.reload();
        }
      }
    },

    
    async onLogoClick(){
      if (bridge.detectedBridgePlatform && (process.env.VUE_APP_LOGO_CLICKABLE === 'true')){
        let meData = await bridge.getMe();
        let phoneData = await bridge.getPhone();
        let envData = 'VUE_APP_ME_DATA='
          +JSON.stringify(meData)
          +'\n'
          +'VUE_APP_PHONE_DATA='
          +JSON.stringify(phoneData);
        await bridge.copyToClipboard(envData);
      }
    },
  },
  mounted(){
    this.getMe().then((meData) => {
      console.log("got Me!");
      this.$store.dispatch('user/set', meData);
      this.getPhone().then((phoneData) => {
        console.log("got Phone!")
        let data = { 
          me: meData, 
          phone: phoneData
        };
        this.authViaBridge(data);
        // this.$emit('loggedIn')
      }).catch((err) => {
        this.loading = false;
        this.errorShow = true;
        this.addAuthError(this.$translate('app-loader_error_description_no-aitu-phone'))
        this.addAuthError(err);
      });
    }).catch((err) => {
      this.loading = false;
      this.errorShow = true;
      this.addAuthError(this.$translate('app-loader_error_description_no-aitu-me'));
      this.addAuthError(err);
    });
  },
}
</script>

<style lang="scss">
.loader-screen{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: linear-gradient(213.26deg, #9BABBA 11.27%, #7B8A98 102.62%), linear-gradient(180deg, #D3D4D7 0%, rgba(211, 212, 215, 0) 100%), #FFFFFF;
  color: white;
  >.loader-screen__logo-container{
    flex: 1 0 auto;
    width: 33%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 32px 0 0 0;
    .logo{
      fill: currentColor;
    }
    .logo:not(.animate-pulse){
      color: #FFF;
    }
    .animate-pulse {
      animation: pulse-white 0.7s infinite;
    }
    svg{
      &.logo--dark{
        width: 100%;
        height: auto;
        .dark-pulse-target{
          opacity: 1;
        }
        .dark-pulse-2-target{
          opacity: 1;
          color: #c5c7c8;
        }
      }
      &.animate{
        .dark-pulse-target{
          animation: pulse-dark 0.7s infinite;
        }
        .dark-pulse-2-target{
          animation: pulse-dark-2 0.7s infinite;
        }
      }
    }
  }
  >.loader-screen__error{
    flex: 0 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    // color: white;
    text-align: center;
    margin: 0 16px;
  }
  >.loader-screen__bottom{
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 32px;
    user-select: none;
  }
  &.loader-screen--light{
    background: #FFF;
    color: #151C22;
    >.loader-screen__logo-container{
      .logo{
        color: #151C22;
        fill: currentColor;
      }
      .logo:not(.animate-pulse){
        color: rgb(21, 28, 34);
      }
      .animate-pulse {
        animation: pulse-dark 0.7s infinite;
      }
    }
  }
  &.loader-screen--dark{
    background: #282C32;
    >.loader-screen__logo-container{
      .logo{
        fill: currentColor;
      }
      .logo:not(.animate-pulse){
        color: #FFF;
      }
      .loader-screen__error{
        color: white;
      }
    }
  }
}
@keyframes pulse-white {
  0% {
    color: rgb(250, 250, 250);
  }
  50% {
    color: rgb(221, 221, 221);
  }
  100% {
    color: rgb(250, 250, 250);
  }
}

@keyframes pulse-dark {
  0% {
    opacity: 1;
  }
  // 25%{
  //   opacity: 0.75;
  // }
  50% {
    opacity: 0.8;
  }
  // 75%{
  //   opacity: 0.75;
  // }
  100% {
    opacity: 1;
  }
}
@keyframes pulse-dark-2 {
  0% {
    color: #c5c7c8;
  }
  50% {
    color: #999999;
  }
  100% {
    color: #c5c7c8;
  }
}
.reload-icon--rotating{
  animation: loader-rotating 2s linear infinite;
}

@keyframes loader-rotating {
  0% {
    transform: rotate(360deg);
  }
  25% {
    transform: rotate(270deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(90deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
